module.exports = __webpack_public_path__ + "static/media/logohome.ea22d9d3.png";